import React from 'react';
import { useVerificationWizard } from '../useVerificationWizard';
import ServicesForm from '../../wizard/forms/ServicesForm';
import PricingForm from '../../wizard/forms/PricingForm';
import VerificationStepActionBar from '../VerificationStepActionBar';
import { VERIFICATION_STEPS } from '../../../types/verification';
import '../../../pages/VerificationWizardPage.css';

const STEP = VERIFICATION_STEPS.SERVICES_PRICING;

const VerifyServicesStep: React.FC = () => {
  const {
    state,
    stepErrors,
    updateServices,
    updateServiceFee,
    saveServices,
    markStepConfirmed,
    markStepSkipped,
    getStepStatus,
    isSaving,
  } = useVerificationWizard();

  const errors = stepErrors[STEP] || {};

  return (
    <div className="wizard-step">
      <h2>Verify Services & Pricing</h2>
      <p className="step-description">Review the clinic's services and fee schedule.</p>

      <div className="verify-section">
        <h3 className="verify-section-heading">
          Services
        </h3>
        <ServicesForm
          services={state.services}
          onUpdateServices={updateServices}
        />
      </div>

      {state.services.length > 0 && (
        <div className="verify-section-divider">
          <h3 className="verify-section-heading">
            Pricing
          </h3>
          <PricingForm
            services={state.services}
            onUpdateFee={updateServiceFee}
            errors={errors}
          />
        </div>
      )}

      <VerificationStepActionBar
        stepStatus={getStepStatus(STEP)}
        isSaving={isSaving}
        onSaveChanges={saveServices}
        onNoChanges={() => markStepConfirmed(STEP)}
        onSkip={(notes) => markStepSkipped(STEP, notes)}
      />
    </div>
  );
};

export default VerifyServicesStep;
